import * as React from "react";
import { NavLink } from "react-router-dom";
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

export class EditButtonGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = { to: '' };
    }

    render() {
        if (this.props.ShowIcon) {
            return (
                <NavLink to={this.props.to} className='btn btn-outline-info m-1 gridButton' onClick={this.props.onClick}>
                    <Octicon icon={getIconByName('pencil')} className='mb-1' ariaLabel={this.props.ariaLabel} /></NavLink>
            );
        }

        return (
            <a id={this.props.id} className='btn btn-link link' tabIndex='0' href={this.props.to} onClick={this.props.onClick} aria-label={this.props.ariaLabel}>Edit</a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/EditButtonGrid.js